import React, { useState, useContext, useEffect, useRef } from "react";
import { Card, ChatContainer, ProfileImage } from "./ChatStyled";
import { UserContext } from "../../context/userContext";

import avatar from './../../utils/images/avatar_fluincr.png';
import minus from './../../utils/images/minus_blue.svg';
import maxi from './../../utils/images/maximize_blue.svg';
import close from './../../utils/images/close_blue.svg';
import video from './../../utils/images/video_chat.svg';
import image from './../../utils/images/images_chat.svg';
import file from './../../utils/images/sticky_note_chat.svg';
import send from './../../utils/images/send.svg';
import smile from './../../utils/images/smile_chat.svg';

import EmojiPicker from "emoji-picker-react";

import { environment } from "./../../utils/constants/constants";
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import { getChatHistory } from "../../api/messagesApi";
import SmallSpinner from "../SmallSpinner/SmallSpinner";
import { postFileBase64 } from "../../api/fileApi";
import { getBase64 } from "../../services/generalSevices";
import ImageUploading from 'react-images-uploading';
import { formatDateLocal, formatTimeLocal, toUTCString } from "../../services/dateServices";
import { handleImageUpload } from "../../services/compress";


export default function Chat({ collaborationDetails, setShowChat }) {

    const bottomRef = useRef(null);

    const { id, userToken, userType, companyId, uniqueName, account } = useContext(UserContext);

    const [messagesLimit, setMessagesLimit] = useState(20);
    const [isLoading, setIsLoading] = useState(true);

    const isAdmin = sessionStorage.getItem('isAdmin');

    let client = null;

    if (userType === 'influencer') {
        client = new W3CWebSocket(`wss://${environment}/chat/stocks/${id}/${collaborationDetails?.company?.id}/1`);
    } else {
        client = new W3CWebSocket(`wss://${environment}/chat/stocks/${collaborationDetails?.influincr?.id}/${companyId}/0`);
    }

    const [messages, setMessages] = useState([]);

    const [hideChat, setHideChat] = useState(false);
    const [showEmojiOptions, setShowEmojiOptions] = useState(false);
    //const [selectedEmoji, setSelectedEmoji] = useState("");

    const [inputChat, setInputChat] = useState('');
    const [imagesToSend, setImagesToSend] = useState([]);

    const [base64Image, setBase64Image] = useState({});
    const [base64File, setBase64File] = useState({});
    const [base64Video, setBase64Video] = useState({});

    const [timeLastMessage, setTimeLastMessage] = useState('');

    /* useEffect(() => {
        if (imagesToSend.length > 0) {
            sendImages();
        }
    }, [imagesToSend]) */

    useEffect(() => {
        if (Object.keys(base64Image).length > 0) {
            sendImage();
        }
    }, [base64Image])

    useEffect(() => {
        if (Object.keys(base64Video).length > 0) {
            sendVideo();
        }
    }, [base64Video])

    useEffect(() => {
        if (Object.keys(base64File).length > 0) {
            sendFile();
        }
    }, [base64File])

    function onClick(emojiData, event) {
        //setSelectedEmoji(emojiData.unified);
        const newText = inputChat.concat(emojiData.emoji)
        setInputChat(newText)
    }

    function sendPong() {
        const payload = {
            message: 'PONG',
            type: '-1',
        };
        //client.onopen = () => client.send(JSON.stringify(payload));
        client.send(JSON.stringify(payload));
    }

    const getMessages = () => {

        if (userType === 'influencer') {
            getChatHistory({ influencerId: id, companyId: collaborationDetails?.company?.id, limit: messagesLimit }).then((response) => {
                setMessages(response);
            })
        } else {
            getChatHistory({ influencerId: collaborationDetails?.influincr?.id, companyId: companyId, limit: messagesLimit }).then((response) => {
                setMessages(response);
            })
        }

    };

    useEffect(() => {
        getMessages();

        client.onopen = (event) => {
            //console.log('WebSocket Client Connected', event);
            setIsLoading(false);
        }
        client.onerror = (event) => {
            //console.warn('An error occurred', event.data);
        }
        client.onmessage = (event) => {
            //console.log(event)
            if (event.data === 'PING') {
                sendPong();
            } else if (JSON.parse(event.data).tipo === '999') {
                getMessages();
            } else {
                //console.log('Llegando mensaje');
                getMessages();
            }
        }

        /* getRoom({ companyId: vendorChat.planner_id, plannerId: id }).then((response) => {
            console.log("ROOM", response)
            setIsVendorBlocked(response.block_planner)
        }) */


    }, [])

    const sendMessage = (event) => {
        event.preventDefault();

        const payload = {
            message: inputChat,
            type: '0',
        };

        if (inputChat.length > 0) {
            //client.onopen = () => client.send(JSON.stringify(payload))
            client.send(JSON.stringify(payload))
        } else {
            //console.log("No se puede")
        }
        setInputChat('')
    }

    /* const sendImages = () => {

        setIsLoading(true);
        console.log(imagesToSend);

        if (imagesToSend.length > 0) {

            const auxImages = imagesToSend.map(async (image) => {
                const fileBody = {
                    base64File: image.data_url.split(',')[1],
                    formatFile: image.file.type.split('/')[1],
                    address: ""
                }
                if (userType === 'influencer') {
                    //fileBody.address = `fluincr/${uniqueName}/message`
                    fileBody.address = `fluincr/${account}/message`

                } else {
                    //fileBody.address = `company/${uniqueName}/message`
                    fileBody.address = `company/${account}/message`
                }
                console.log(fileBody)
                return await postFileBase64({ body: fileBody, token: userToken }).then((response) => {
                    const urlImage = response.replace(/['"]+/g, '')
                    return (urlImage);
                })
            })

            Promise.all(auxImages).then(arrayImages => {
                setIsLoading(false);
                const payload = {
                    message: JSON.stringify(arrayImages),
                    type: '1',
                };
                console.log(JSON.stringify(payload))

                client.send(JSON.stringify(payload));
                setImagesToSend([]);
            })
        }
    } */

    const sendImage = () => {

        setIsLoading(true);

        if (Object.keys(base64Image).length > 0) {

            const fileBody = {
                base64File: base64Image.base64.split(',')[1],
                formatFile: base64Image.type,
                address: ""
            }
            if (userType === 'influencer') {
                fileBody.address = `fluincr/${account}/message`
            } else {
                fileBody.address = `company/${account}/message`
            }

            postFileBase64({ body: fileBody, token: userToken }).then((responseFile) => {

                if (responseFile.length > 0) {
                    const urlFile = responseFile.replace(/['"]+/g, '')

                    setIsLoading(false);
                    const auxArray = [urlFile]

                    const payload = {
                        message: JSON.stringify(auxArray),
                        type: '1',
                    };

                    client.send(JSON.stringify(payload));
                    setBase64Image({})
                }
            })
        }
    }


    const sendFile = () => {

        setIsLoading(true);

        if (Object.keys(base64File).length > 0) {

            const fileBody = {
                base64File: base64File.base64.split(',')[1],
                formatFile: base64File.type,
                address: ""
            }
            if (userType === 'influencer') {
                //fileBody.address = `fluincr/${uniqueName}/message`
                fileBody.address = `fluincr/${account}/message`
            } else {
                //fileBody.address = `company/${uniqueName}/message`
                fileBody.address = `company/${account}/message`
            }

            postFileBase64({ body: fileBody, token: userToken }).then((responseFile) => {

                if (responseFile.length > 0) {
                    const urlFile = responseFile.replace(/['"]+/g, '')
                    setIsLoading(false);
                    const auxArray = [urlFile]

                    const auxMessage = { uri: JSON.stringify(auxArray), file_name: JSON.stringify(base64File.name) }
                    const payload = {
                        message: JSON.stringify(auxMessage),
                        type: '2',
                    };

                    client.send(JSON.stringify(payload));
                    setBase64File({})
                }
            })
        }
    }

    const sendVideo = () => {
        setIsLoading(true);

        if (Object.keys(base64Video).length > 0) {

            const fileBody = {
                base64File: base64Video.base64.split(',')[1],
                formatFile: base64Video.type,
                address: ""
            }
            if (userType === 'influencer') {
                //fileBody.address = `fluincr/${uniqueName}/message`
                fileBody.address = `fluincr/${account}/message`
            } else {
                //fileBody.address = `company/${uniqueName}/message`
                fileBody.address = `company/${account}/message`
            }


            postFileBase64({ body: fileBody, token: userToken }).then((responseFile) => {

                if (responseFile.length > 0) {
                    const urlFile = responseFile.replace(/['"]+/g, '')

                    setIsLoading(false);
                    const auxArray = [urlFile]

                    /* const auxMessage = { uri: JSON.stringify(auxArray), file_name: JSON.stringify(base64Video.name) } */

                    const payload = {
                        //message: JSON.stringify(auxMessage),
                        message: JSON.stringify(auxArray),
                        type: '3',
                    };

                    client.send(JSON.stringify(payload));
                    setBase64Video({})
                }
            })
        }
    }

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages])

    return (
        <ChatContainer showEmojiOptions={showEmojiOptions} isAdmin={isAdmin}>
            <div className="chatHeader">
                <div className="userData">

                    {(userType === 'influencer') ? (<ProfileImage image={(collaborationDetails?.company?.imageProfile !== '' && collaborationDetails?.company?.imageProfile !== null) ? collaborationDetails?.company?.imageProfile : avatar} />) : (<ProfileImage image={(collaborationDetails?.influincr?.imageProfile !== '' && collaborationDetails?.influincr?.imageProfile !== null) ? collaborationDetails?.influincr?.imageProfile : avatar} />)}

                    <div className="textData">
                        {(userType === 'influencer') ? (<p className="userName"> <span>{collaborationDetails?.company?.nameCompany}</span>  </p>) : (<p className="userName"> <span>{collaborationDetails?.influincr?.givenName}</span>  </p>)}
                        {/* <p className="subtext">no se que va</p> */}
                    </div>

                </div>
                <div className="buttons">
                    {(hideChat) ? (<img src={maxi} alt="" onClick={() => setHideChat(!hideChat)} className="maxi" />) : (<img src={minus} alt="" onClick={() => setHideChat(!hideChat)} />)}


                    <img src={close} alt="" onClick={() => setShowChat(false)} />
                </div>
            </div>
            {(!hideChat) && (<>
                <div className="messages">

                    {(isLoading) && <SmallSpinner />}

                    {messages.map((mssg, index) => {
                        if (index + 1 === messages.length) {
                            //setTimeLastMessage(mssg.sending_date.toString())
                        }
                        return (
                            <Card key={mssg.id} typeUser={(mssg.tipoUsuario === 'PLANNER') ? 'influencer' : 'company'} myUser={userType}>
                                <div>
                                    {(userType === 'influencer' && mssg.tipoUsuario === 'VENDOR') && (<ProfileImage image={(collaborationDetails?.company?.imageProfile !== '' && collaborationDetails?.company?.imageProfile !== null) ? collaborationDetails?.company?.imageProfile : avatar} />)}


                                    {(userType === 'company' && mssg.tipoUsuario === 'PLANNER') && (<ProfileImage image={(collaborationDetails?.influincr?.imageProfile !== '' && collaborationDetails?.influincr?.imageProfile !== null) ? collaborationDetails?.influincr?.imageProfile : avatar} />)}
                                </div>

                                <div className="message">
                                    {(mssg.tipo === 0) ?
                                        (<p className="textMessage">{mssg.message}</p>) :
                                        (mssg.tipo === 1) ?
                                            (<div className="imagesContainer">
                                                {(JSON.parse(mssg.message)).map((item) => {
                                                    return (<>
                                                        <a href={item} target="_blank" download >
                                                            <img src={item} alt="chat phot" className='imageAttached' />
                                                        </a>
                                                    </>
                                                    )
                                                })}
                                            </div>) :
                                            (mssg.tipo === 2) ?
                                                (<a href={(JSON.parse(mssg.message).uri).slice(2, -2)} download={(JSON.parse(mssg.message).file_name)} >
                                                    <div className="file">
                                                        <div className="cover">
                                                            <img src={file} alt="file" />
                                                        </div>
                                                        <div className="name">
                                                            {/* <p>{JSON.parse(mssg.message)?.file_name}</p> */}
                                                            <p>{(JSON.parse(mssg.message).file_name).slice(1, -1)}</p>
                                                        </div>
                                                    </div>
                                                </a>) :
                                                (mssg.tipo === 3) &&
                                                (<div className="imagesContainer">
                                                    <video src={JSON.parse(mssg.message)[0]} alt="chat video" className='imageAttached' preload="auto" controls />

                                                </div>)
                                    }


                                    <p className='time'>{(new Date(new Date().toUTCString()).toDateString() !== new Date(mssg.sending_date).toDateString()) && (`${formatDateLocal(mssg.sending_date)} / `)}  {formatTimeLocal(mssg.sending_date)} </p>
                                </div>

                            </Card>
                        )
                    })}
                    <div ref={bottomRef} style={{ width: '10px', height: '10px' }} />

                </div>

                <div className="chatFooter">
                    <div className="chatMenu">


                        {/* <ImageUploading
                            multiple
                            value={imagesToSend}
                            onChange={(imageList, addUpdateIndex) => { setImagesToSend(imageList); }}
                            maxNumber={3}
                            dataURLKey="data_url"
                        >
                            {({
                                imageList,
                                onImageUpload,
                                isDragging,
                                dragProps,
                            }) => (
                                <div className="upload__image-wrapper">
                                    <button type='button'
                                        onClick={onImageUpload}
                                        {...dragProps}
                                        className="imageUploadButton"
                                    >
                                        <img src={image} alt="send phot" className="imageFile" />
                                    </button>
                                </div>
                            )}
                        </ImageUploading> */}

                        <label htmlFor="chat-image-input" className="fileLabel">
                            <img src={image} alt="send phot" className="imageFile" />
                        </label>

                        <input type="file" id="chat-image-input" accept="image/png, image/jpeg" onChange={(e) => {
                            handleImageUpload({ event: e, maxWidthOrHeight: 600 }).then((compressedFile) => {
                                getBase64({ file: compressedFile }).then((image) => {
                                    setBase64Image({ base64: image, name: e.target.files[0].name, type: e.target.files[0].type.split('/')[1] })
                                })
                            })
                        }} disabled={isAdmin} />

                        <label htmlFor="chat-video-input" className="fileLabel">
                            <img src={video} alt="send video" className="videoFile" />
                        </label>
                        <input type="file" id="chat-video-input" accept="video/mp4,video/x-m4v, video/mov, video/*" onChange={(e) => {
                            getBase64({ file: e.target.files[0] }).then((data) => {
                                setBase64Video({ base64: data, name: e.target.files[0].name, type: e.target.files[0].type.split('/')[1] });
                            });
                        }} disabled={isAdmin} />


                        <label htmlFor="chat-file-input" className="fileLabel">
                            <img src={file} alt="send file" className="file" />
                        </label>
                        <input type="file" id="chat-file-input" accept=".pdf, .txt, application/pdf, .doc, .docx, application/msword, .xls,.xlsx, application/vnd.ms-excel, .ppt, .pptx, application/vnd.ms-powerpoint, text/plain" onChange={(e) => {
                            getBase64({ file: e.target.files[0] }).then((data) => {
                                setBase64File({ base64: data, name: e.target.files[0].name, type: e.target.files[0].type.split('/')[1] });
                            }
                            );
                        }} disabled={isAdmin} />


                        <div className="inputContainer">
                            <form action="submit">
                                <input type="text" value={inputChat} onChange={(event) => {
                                    setInputChat(event.target.value)
                                }} disabled={isAdmin} />
                                <button type='submit' onClick={sendMessage} className='sendButton' disabled={isAdmin}><img src={send} alt="send" /></button>
                            </form>

                            <img src={smile} alt="" onClick={() => {
                                if (!isAdmin) {
                                    setShowEmojiOptions(!showEmojiOptions)
                                }
                            }} className='emoji' />
                        </div>
                    </div>
                    {(showEmojiOptions) && (<EmojiPicker
                        onEmojiClick={onClick}
                        //autoFocusSearch={false}
                        // theme={Theme.AUTO}
                        searchDisabled
                        // skinTonePickerLocation={SkinTonePickerLocation.PREVIEW}
                        height={'35vh'}
                        //width="50%"
                        // emojiVersion="0.6"
                        // lazyLoadEmojis={true}
                        // previewConfig={{
                        //   defaultCaption: "Pick one!",
                        //   defaultEmoji: "1f92a" // 🤪
                        // }}
                        // suggestedEmojisMode={SuggestionMode.RECENT}
                        skinTonesDisabled
                    // searchPlaceHolder="Filter"
                    //defaultSkinTone={SkinTones.MEDIUM}
                    // emojiStyle={EmojiStyle.NATIVE}
                    // categories={[
                    //   {
                    //     name: "Fun and Games",
                    //     category: Categories.ACTIVITIES
                    //   },
                    //   {
                    //     name: "Smiles & Emotions",
                    //     category: Categories.SMILEYS_PEOPLE
                    //   },
                    //   {
                    //     name: "Flags",
                    //     category: Categories.FLAGS
                    //   },
                    //   {
                    //     name: "Yum Yum",
                    //     category: Categories.FOOD_DRINK
                    //   }
                    // ]}
                    />)}




                </div></>)}

        </ChatContainer>
    )
}